import React, { useEffect, useRef, useState } from "react";
import { getStudentAssignmentMicrosoftLink } from "ClassRoom/modules/ClassRoomModule";
import { connect } from "react-redux";
import Loading from "UIComponents/Loading";
import IframeWrapper from "../IframeWrapper";
import { useI18n } from "Hooks";

// This component is used only to embed microsoft submission templates for staff in the Classroom Media Manager

const MicrosoftFileViewer = ({
  studentSubmissionId,
  attachmentId,
  getStudentAssignmentMicrosoftLink,
}) => {
  const [url, setUrl] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef(null);
  const { t } = useI18n(["a11y"]);

  const iframeLoaded = () => {
    if (isLoading) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function getUrl() {
      setIsLoading(true);
      const attachmentUrl = await getStudentAssignmentMicrosoftLink({
        attachmentId,
        submissionId: studentSubmissionId,
        showProgress: false,
      });
      const documentLink = new URL(attachmentUrl);
      documentLink.searchParams.append("wdskipfccheck", "0");
      setUrl(documentLink.toString());
      setIsLoading(false);
    }
    getUrl();
  }, [studentSubmissionId, attachmentId, getStudentAssignmentMicrosoftLink]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <IframeWrapper
      iframeSrc={url}
      iframeRef={iframeRef}
      iframeLoaded={iframeLoaded}
      id={"microsoft-doc-embedding-iframe"}
      title={t("a11y:microsoft_document_preview")}
    />
  );
};

const mapActionCreators = {
  getStudentAssignmentMicrosoftLink,
};
export default connect(null, mapActionCreators)(MicrosoftFileViewer);
